export const service = {
  uz: {
    serviceSectionTitle: "Bizning xizmatlar",
    serviceSectionText:
      "Individual yondashuv va innovatsion texnalogiyalarni bir makonda birlashtirdik",
    serviceSectionEyeExamTitle: "Turli ko’z kasalliklari diagnostikasi va davolash",
    serviceSectionEyeExamText:
      "Ko'zni Tekshirish Nima? Homiladorlik yoki muammolarni bartaraf etish yo'q. Sat…",
    serviceSectionDryEyeTitle: "Kataraktani davolash",
    serviceSectionDryEyeText:
      "Ko'zni Tekshirish Nima? Homiladorlik yoki muammolarni bartaraf etish yo'q. Sat…",
    serviceSectionContactLensExamTitle: "Glaukomani davolash",
    serviceSectionContactLensExamText:
      "Ko'zni Tekshirish Nima? Homiladorlik yoki muammolarni bartaraf etish yo'q. Sat…",
    serviceSectionUrgentVisionCareTitle: "Lazerli ko'z korrektsiyasi",
    serviceSectionUrgentVisionCareText:
      "Ko'zni Tekshirish Nima? Homiladorlik yoki muammolarni bartaraf etish yo'q. Sat…",
    serviceSectionCompleteOpticalTitle: "Vitreoretinal jarrohlik",
    serviceSectionCompleteOpticalText:
      "Ko'zni Tekshirish Nima? Homiladorlik yoki muammolarni bartaraf etish yo'q. Sat…",
    serviceSectionAdvOcularCareTitle: "Ko’zning boshqa kasalliklari",
    serviceSectionAdvOcularCareText:
      "Ko'zni Tekshirish Nima? Homiladorlik yoki muammolarni bartaraf etish yo'q. Sat…",
    serviceTitle: "Barcha Xizmatlar",
    serviceLinkText: "Barcha xizmatlarni ko'rish",
    serviceSingleLinkText: "Xizmatni ko'rish",
    allServiceFaqTitle:
      "Sizga ko'zni sifatli parvarish qilishni taqdim qilamiz",
    allServiceFaqQuestion1: "Ko'zni parvarish qilish markazi haqida",
    allServiceFaqAnswer1:
      "Oftalmologiya markazining oftalmologlari sizning ko'zingizni parvarish qilish bo'yicha barcha ehtiyojlaringiz bo'yicha sizga yordam berishga tayyor. Bizning yuqori malakali ko'zni parvarish qilish bo'yicha mutaxassislarimiz saqlashga e'tibor berishadi.",
    allServiceFaqQuestion2: "Bizning ko'zni parvarish qilish vazifamiz",
    allServiceFaqAnswer2:
      "Oftalmologiya markazi bemorlarga ko'zni parvarish qilish va texnologiya sohasida birinchi o'rinda turadi. Biz diagnostika, teletibbiyot bo'yicha ilg'or tajribalarni taqdim etamiz.",
    allServiceFaqQuestion3: "Optoelektronikadagi texnologiyalar",
    allServiceFaqAnswer3:
      "Ko'zni parvarish qilish markazimizning optik mutaxassislari tomonidan maxsus tayyorlangan va faqat ko'zlaringiz uchun optimallashtirilgan linzalardan bahramand bo'ling. Bizning linzalarimiz zamonaviy laboratoriyada ishlab chiqariladi.",
    allServiceEyeDiseasePRKTitle: "Fotorefraktsion keratektomiya (FRK)",
    allServiceEyeDiseasePRKText:
      "Homiladorlik yoki muammolarni bartaraf etish yo'q. Oson tanishlar yo'q. Forex savdosi sohasida juda arzon martaba. Yengish uchun qulaylik",
    allServiceEyeDiseasePRKList1: "Homiladorlik va sho'ng'in",
    allServiceEyeDiseasePRKList2: "Oson tanishlar yo'q",
    allServiceEyeDiseasePRKList3: "Yengish uchun qulaylik",
    allServiceEyeDiseasePRKList4: "Turli maqsadlar uchun shokolad tashish",
    allServiceEyeDiseaseVCSTitle: "Ko'rishni tuzatish operatsiyasi",
    allServiceEyeDiseaseVCSText:
      "Homiladorlik yoki muammolarni bartaraf etish yo'q. Oson tanishlar yo'q. Forex savdosi sohasida juda arzon martaba. Yengish uchun qulaylik",
    allServiceEyeDiseaseVCSList1: "Homiladorlik va sho'ng'in",
    allServiceEyeDiseaseVCSList2: "Oson tanishlar yo'q",
    allServiceEyeDiseaseVCSList3: "Yengish uchun qulaylik",
    allServiceEyeDiseaseVCSList4: "Turli maqsadlar uchun shokolad tashish",
  },
  ru: {
    serviceSectionTitle: "Услуги",
    serviceSectionText:
      "Мы объединили индивидуальный подход и инновационные технологии в одном месте",
    serviceSectionEyeExamTitle: "Диагностика и лечение различных заболеваний глаз",
    serviceSectionEyeExamText:
      "Что такое Офтальмологический Осмотр? Никакой беременности или устранения неполадок. Сб…",
    serviceSectionDryEyeTitle: "Лечение катаракты",
    serviceSectionDryEyeText:
      "Что такое Офтальмологический Осмотр? Никакой беременности или устранения неполадок. Сб…",
    serviceSectionContactLensExamTitle: "Лечение глаукомы",
    serviceSectionContactLensExamText:
      "Что такое Офтальмологический Осмотр? Никакой беременности или устранения неполадок. Сб…",
    serviceSectionUrgentVisionCareTitle: "Лазерная коррекция зрения",
    serviceSectionUrgentVisionCareText:
      "Что такое Офтальмологический Осмотр? Никакой беременности или устранения неполадок. Сб…",
    serviceSectionCompleteOpticalTitle: "Витреоретинальная хирургия",
    serviceSectionCompleteOpticalText:
      "Что такое Офтальмологический Осмотр? Никакой беременности или устранения неполадок. Сб…",
    serviceSectionAdvOcularCareTitle: "Другие офтальмологические болезни",
    serviceSectionAdvOcularCareText:
      "Что такое Офтальмологический Осмотр? Никакой беременности или устранения неполадок. Сб…",
    serviceTitle: "Все Услуги",
    serviceLinkText: "Просмотреть все услуги",
    serviceSingleLinkText: "Посмотреть услугу",
    allServiceFaqTitle: "Предоставляя Вам Качественный Уход За Глазами",
    allServiceFaqQuestion1: "О центре офтальмологической помощи",
    allServiceFaqAnswer1:
      "Врачи-офтальмологи офтальмологического центра готовы помочь вам во всех ваших потребностях в уходе за глазами. Наши высококвалифицированные специалисты по уходу за глазами сосредоточены на поддержании.",
    allServiceFaqQuestion2: "Наша миссия по уходу за глазами",
    allServiceFaqAnswer2:
      "Офтальмологический центр находится на переднем крае офтальмологической помощи и технологий для пациентов. Мы предоставляем передовые методы диагностики, телемедицину.",
    allServiceFaqQuestion3: "Технологии в оптоэлектронике",
    allServiceFaqAnswer3:
      "Насладитесь линзами, изготовленными по индивидуальному заказу и оптимизированными исключительно для ваших глаз оптическими специалистами нашего центра по уходу за глазами. Наши линзы производятся в современной лаборатории.",
    allServiceEyeDiseasePRKTitle: "Фоторефракционная кератэктомия (ФРК)",
    allServiceEyeDiseasePRKText:
      "Никакой беременности или устранения неполадок. Легких знакомств не бывает. Очень недорогая карьера в сфере торговли на рынке Форекс. Комфорт, который нужно превзойти",
    allServiceEyeDiseasePRKList1: "Беременность и дайвинг",
    allServiceEyeDiseasePRKList2: "Легких знакомств не бывает",
    allServiceEyeDiseasePRKList3: "Комфорт, который нужно превзойти",
    allServiceEyeDiseasePRKList4: "Перевозка шоколада различного назначения",
    allServiceEyeDiseaseVCSTitle: "Операция по коррекции зрения",
    allServiceEyeDiseaseVCSText:
      "Никакой беременности или устранения неполадок. Легких знакомств не бывает. Очень недорогая карьера в сфере торговли на рынке Форекс. Комфорт, который нужно превзойти",
    allServiceEyeDiseaseVCSList1: "Беременность и дайвинг",
    allServiceEyeDiseaseVCSList2: "Легких знакомств не бывает",
    allServiceEyeDiseaseVCSList3: "Комфорт, который нужно превзойти",
    allServiceEyeDiseaseVCSList4: "Перевозка шоколада различного назначения",
  },
  tj: {
    serviceSectionTitle: "Хизматрасонӣ",
    serviceSectionText: "Хидматҳои маъмултарини моро дар зер санҷед",
    serviceSectionEyeExamTitle: "Муоинаи чашм",
    serviceSectionEyeExamText:
      "Имтиҳони чашм чист? Ҳомиладорӣ ва ҳалли мушкилот вуҷуд надорад. Ҷамъ…",
    serviceSectionDryEyeTitle: "Ҷарроҳии хушки чашм",
    serviceSectionDryEyeText:
      "Имтиҳони чашм чист? Ҳомиладорӣ ва ҳалли мушкилот вуҷуд надорад. Ҷамъ…",
    serviceSectionContactLensExamTitle: "Барқарорсозии ретиналӣ",
    serviceSectionContactLensExamText:
      "Имтиҳони чашм чист? Ҳомиладорӣ ва ҳалли мушкилот вуҷуд надорад. Ҷамъ…",
    serviceSectionUrgentVisionCareTitle: "Ҷарроҳии лазерии чашм",
    serviceSectionUrgentVisionCareText:
      "Имтиҳони чашм чист? Ҳомиладорӣ ва ҳалли мушкилот вуҷуд надорад. Ҷамъ…",
    serviceSectionCompleteOpticalTitle: "Хизматрасонии оптикӣ",
    serviceSectionCompleteOpticalText:
      "Имтиҳони чашм чист? Ҳомиладорӣ ва ҳалли мушкилот вуҷуд надорад. Ҷамъ…",
    serviceSectionAdvOcularCareTitle: "Тартиби ҷарроҳӣ",
    serviceSectionAdvOcularCareText:
      "Имтиҳони чашм чист? Ҳомиладорӣ ва ҳалли мушкилот вуҷуд надорад. Ҷамъ…",
    serviceTitle: "Ҳама Хидматҳо",
    serviceLinkText: "Ҳама хидматҳоро тамошо кунед",
    serviceSingleLinkText: "Хидматро тамошо кунед",
    allServiceFaqTitle: "Таъмини Нигоҳубини Босифати Чашм",
    allServiceFaqQuestion1: "Дар бораи маркази нигоҳубини чашм",
    allServiceFaqAnswer1:
      "Офтальмологҳои маркази офтальмологӣ омодаанд ба шумо дар ҳама ниезҳои нигоҳубини чашм кӯмак расонанд. Мутахассисони баландихтисоси нигоҳубини чашми мо ба нигоҳдорӣ тамаркуз мекунанд.",
    allServiceFaqQuestion2: "Вазифаи мо оид ба нигоҳубини чашм",
    allServiceFaqAnswer2:
      "Маркази офтальмологӣ дар канори пеши ерии офтальмологӣ ва технологияи беморон ҷойгир аст. Мо усулҳои пешрафтаи ташхис, телемедицинаро пешниҳод менамоем.",
    allServiceFaqQuestion3: "Технология дар оптоэлектроника",
    allServiceFaqAnswer3:
      "Аз линзаҳои фармоишӣ ва танҳо барои чашмони шумо оптимизатсияшуда аз ҷониби мутахассисони оптикии маркази нигоҳубини чашми мо лаззат баред. Линзаҳои мо дар лабораторияи муосир истеҳсол карда мешаванд.",
    allServiceEyeDiseasePRKTitle: "Кератектомияи фоторефраксионӣ (ФРК)",
    allServiceEyeDiseasePRKText:
      "Ҳомиладорӣ е ҳалли мушкилот нест. Знакомств осон нест. Карераи хеле арзон дар савдои forex. Бароҳатӣ барои задан",
    allServiceEyeDiseasePRKList1: "Ҳомиладорӣ ва ғаввосӣ",
    allServiceEyeDiseasePRKList2: "Знакомств осон нест",
    allServiceEyeDiseasePRKList3: "Бароҳатӣ барои задан",
    allServiceEyeDiseasePRKList4: "Интиқоли шоколадҳои таъиноти гуногун",
    allServiceEyeDiseaseVCSTitle: "Ҷарроҳии ислоҳи биниш",
    allServiceEyeDiseaseVCSText:
      "Ҳомиладорӣ е ҳалли мушкилот нест. Знакомств осон нест. Карераи хеле арзон дар савдои forex. Бароҳатӣ барои задан",
    allServiceEyeDiseaseVCSList1: "Ҳомиладорӣ ва ғаввосӣ",
    allServiceEyeDiseaseVCSList2: "Знакомств осон нест",
    allServiceEyeDiseaseVCSList3: "Бароҳатӣ барои задан",
    allServiceEyeDiseaseVCSList4: "Интиқоли шоколадҳои таъиноти гуногун",
  },
};
